import React, { useState } from "react";
import ProjectCard from "./ProjectCard";
import {
  ongoingProjects,
  completedProjects
} from "../data/projectsData";
import ongoingImage from "../Images/work/WhatsApp Image 2026-01-12 at 16.21.24.jpg";
import "../css/Projects.css"; // Add a CSS file for responsive styles

const Projects = () => {
  const [activeTab, setActiveTab] = useState("ongoing");

  return (
    <div className="projects-container">
      {/* Full-width image banner */}
      <div className="projects-banner">
        <img
          src="/Images/Image/view-heavy-machinery-used-construction-industry (2).jpg"
          alt="Projects Banner"
          className="projects-banner-image"
        />
        <h1 className="projects-banner-title">OUR PROJECTS</h1>
      </div>

      <div className="projects-content">
        {/* Header */}
        <div className="projects-header">
          <div className="projects-subtitle">
            <span className="projects-subtitle-dot"></span>
            <span>Our Portfolio</span>
          </div>
          <h1 className="projects-title">Projects</h1>
          <p className="projects-description">
            Explore our portfolio of <span>completed and ongoing</span> construction projects
          </p>
        </div>

        {/* Tabs */}
        <div className="projects-tabs">
          <button
            onClick={() => setActiveTab("ongoing")}
            className={`projects-tab ${activeTab === "ongoing" ? "active" : ""}`}
          >
            ◎ Ongoing Projects
          </button>
          <button
            onClick={() => setActiveTab("completed")}
            className={`projects-tab ${activeTab === "completed" ? "active" : ""}`}
          >
            ✓ Completed Projects
          </button>
        </div>

        {/* Projects Grid */}
        <div className="projects-grid">
          {activeTab === "ongoing"
            ? ongoingProjects.map((point, index) => (
                <ProjectCard
                  key={index}
                  title={`Project ${index + 1}`}
                  description={point}
                  status="ongoing"
                  image={ongoingImage}
                  index={index}
                />
              ))
            : completedProjects.map((point, index) => (
                <ProjectCard
                  key={index}
                  title={`Project ${index + 1}`}
                  description={point}
                  status="completed"
                  image={
                    [
                      "/images/project1.jpg",
                      "/images/project2.jpg",
                      "/images/project3.jpg",
                      "/images/project4.jpg"
                    ][index % 4]
                  }
                  index={index}
                />
              ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
